import { render, staticRenderFns } from "./SysIdentityManageList.vue?vue&type=template&id=7bca3b3e&scoped=true&"
import script from "./SysIdentityManageList.vue?vue&type=script&lang=js&"
export * from "./SysIdentityManageList.vue?vue&type=script&lang=js&"
import style0 from "./SysIdentityManageList.vue?vue&type=style&index=0&id=7bca3b3e&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7bca3b3e",
  null
  
)

export default component.exports